import React from 'react';

import useUser from '../../hooks/useUser';
import config from '../../config/config';
import BetaTag from './BetaTag';

const BetaFeature = props => {
  const user = useUser();
  const isVisible = (
    user?.provider?.is_beta_tester
    || user?.patient?.is_beta_tester
    || false
  );
  if (isVisible) {
    return (
      <>
        {props.hideTag ? null : <BetaTag />}
        {props.children}
      </>
    );
  }
  return <></>;
};

export default BetaFeature;